import { useEffect } from "react";
import "../../App.css";
import FF from "../../images/iPhone 15 Mockup, Perspective (1).png";
import Home from "../../images/filmfriends/Home.png";
import Swipe from "../../images/filmfriends/swipe.png";
import SwipeDiscover from "../../images/filmfriends/iPhone 15 Mockup, Perspective (3).png";
import List from "../../images/filmfriends/iPhone 15 Pro Max Mockup, Front View (1).png";
import ContentBlock from "../contentBlock/contentBlock";
import "./FilmFriends.css";
import SectionBlock from "../sectionBlock/sectionBlock";
import { useMediaQuery } from "react-responsive";
import home1 from "../../images/filmfriends/Frame 1010106249.png";
import home2 from "../../images/filmfriends/Frame 1010106250.png";
import home3 from "../../images/filmfriends/Frame 1010106266.png";
import home4 from "../../images/filmfriends/Frame 1010106266.logo.png";
import Carusel from "../carusel/carusel";

export default function FilmFriends() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const filmSlides = [home1, home3, home2, home4];

  return (
    <>
      <div className="filmfriends-container">
        {/* Header Section */}
        <div className="ff-header-section">
          <div className="ff-header-content">
            <div className="header-text">
              <h1 className="title">FilmFriends</h1>
              <div className="extra-text">
                <p className="text">
                  FilmFriends is an app where I was part of designing and
                  building it from scratch with React Native. The app helps
                  users pick a movie by swiping. This makes the choice quick and
                  fun. I worked on the frontend and the full UI and UX flow. The
                  final product was successfully deployed on the App Store.
                </p>
                {!isMobile && (
                  <p className="text">
                    Made with:
                    <strong> Figma ◦ React Native ◦ Firebase ◦ TMDB API</strong>
                  </p>
                )}
              </div>
            </div>
            <div
              style={{ gridColumn: "span 2" }}
              className={
                isMobile
                  ? "carousel-mobile-container"
                  : "carousel-desktop-container"
              }
            >
              <Carusel slides={filmSlides} />
            </div>
            {isMobile && (
              <div className="made-with-text-container">
                <p className="textSBold">
                  Made with
                  <ul class="text">
                    <li>Figma</li>
                    <li>React Native</li>
                    <li>Firebase</li>
                    <li>TMDB API</li>
                  </ul>
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="process-section">
          <h1 className="title">Time Line</h1>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >
              {isMobile ? (
                <div
                  style={{
                    display: "flex",
                    gap: "2rem",
                    flexDirection: "column",
                    marginBottom: "2rem",
                  }}
                >
                  <ContentBlock
                    title="1. Ideation"
                    text="The project began with a brainstorming and ideation session to refine the concept for a film selection app. were made in Figma. Two designs were developed into interactive prototypes in Figma."
                    style={{ paddingTop: "0px" }}
                  />

                  <ContentBlock
                    title="2. Figma Design"
                    text="A Figma design was developed for the app's interface."
                    style={{ paddingTop: "0px" }}
                  />

                  <ContentBlock
                    title="3. React Native Mobile App"
                    text="Making application in React Native, works for both android and IOS. Firebase as database. "
                    style={{ paddingTop: "0px" }}
                  />

                  <ContentBlock
                    title="4. User Testing"
                    text="The app was evaluated with focus groups."
                    style={{ paddingTop: "0px" }}
                  />
                  <ContentBlock
                    title="5. Redesign"
                    text="The interface was redesigned in Figma based on user feedback. The design was then implemented in the application."
                    style={{ paddingTop: "0px" }}
                  />
                  <ContentBlock
                    title="6. Release to App Store"
                    text="The finished app was released to the App Store."
                    style={{ paddingTop: "0px" }}
                  />
                </div>
              ) : (
                <>
                  <div className="timeline"></div>
                  <div className="timelineGrid">
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="1. Ideation"
                      text="The project began with a brainstorming and ideation session to refine the concept for a film selection app. were made in Figma. Two designs were developed into interactive prototypes in Figma."
                      style={{ paddingTop: "0px" }}
                    />
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="2. Figma Design"
                      text="A Figma design was developed for the app's interface."
                      style={{ paddingTop: "0px" }}
                    />
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="3. React Native Mobile App"
                      text="Making application in React Native, works for both android and IOS. Firebase as database. "
                      style={{ paddingTop: "0px" }}
                    />
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="4. User Testing"
                      text="The app was evaluated with focus groups."
                      style={{ paddingTop: "0px" }}
                    />
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="5. Redesign"
                      text="The interface was redesigned in Figma based on user feedback. The design was then implemented in the application."
                      style={{ paddingTop: "0px" }}
                    />
                    <div className="timelineLine"></div>
                    <ContentBlock
                      title="6. Release to App Store"
                      text="The finished app was released to the App Store."
                      style={{ paddingTop: "0px" }}
                    />
                  </div>
                  <div
                    style={{
                      height: "1000px",
                      width: "30%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                      margin: "20px",
                    }}
                  >
                    <img
                      src={Home}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "auto",
                        maxHeight: "40rem",
                        objectFit: "contain",
                      }}
                      alt="Wireframes"
                    />
                    <img
                      src={Swipe}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "auto",
                        maxHeight: "40rem",
                        objectFit: "contain",
                      }}
                      alt="Wireframes"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="app-section">
          <div className="app-content">
            <h1 className="title">Final App</h1>

            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                }}
              >
                <img className="app-image" src={FF} alt="FilmFirends" />
                <p className="text">
                  The completed application is a film selection app that allows
                  users to create watchlists, swipe on movies, and host voting
                  sessions with friends to decide on a movie. It utilizes
                  Firebase as a database and integrates the TMDB API to retrieve
                  movie information.
                </p>
              </div>
            </div>
            <div className="app-lower-content">
              {isMobile && (
                <img
                  src={SwipeDiscover}
                  className="app-image"
                  alt="Master Thesis"
                />
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "30px",
                }}
              >
                <SectionBlock
                  title="Discover"
                  text="With FilmFriends, staying up to date with the latest movies and discovering new films in your favorite categories is effortless. Trending and upcoming movies are displayed on the homepage, making it easy to find films you might be interested in."
                />
                <SectionBlock
                  title="Swipe"
                  text=" Swipe through movies to find your next favorite! Swipe with your partner or friends to discover a movie match. The swipe feature serves multiple purposes, it helps you choose a film to watch together or save movies you're interested in to a watchlist for your next movie night."
                />
              </div>
              {!isMobile && (
                <img
                  src={SwipeDiscover}
                  className="app-image"
                  alt="Master Thesis"
                />
              )}
            </div>
            <div className="app-lower-content">
              <img src={List} className="app-image" alt="Master Thesis" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "30px",
                }}
              >
                <SectionBlock
                  title="Watchlists"
                  text="Create watchlists for future movie nights and share them with friends! Build personal watchlists with your favorite movies or collaborate on shared lists where everyone can add their top picks"
                />
                <SectionBlock
                  title="Vote"
                  text="Struggling to agree on what to watch? No problem! With a voting session, the debate ends quickly. Add up to eight movies to the list, let everyone vote, and the winner is chosen."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
